import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { OnboardingRegistration } from '@/common/models';
import { RegistrationsHelper } from '@/common/helpers';

@Component({
  components: {
  },
})
export default class RegistrationDetailsHeader extends Vue {

  @Prop({ required: true }) onboardingRegistration!: OnboardingRegistration;

  get onboardingRegistrationStatus(): string {
    return RegistrationsHelper.formatStatus(this.onboardingRegistration.status);
  }

  @Emit()
  goBack() {
    this.$emit('goBack');
  }
}
